import React from 'react'
import PropTypes from 'prop-types'
import MainTitleLogo from '@generators/htmlComponents/icons/MainTitleLogo'
import Text from './Text'

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '22px 0',
  },
  title: {
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
    fontSize: 26,
  },
  textContainer: {
    flexDirection: 'column',
    gap: 0
  },
  topTitle: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 0,
  },
  bottomTitle: {
    fontSize: 14,
    marginTop: 0,
  },
  meddiumTitle: {
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
    fontSize: 26,
    marginTop: 5,
    marginBottom: 5,
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '22px 0 22px 0',
    gap: 0,
    justifyContent: 'space-between',
  },
  internalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}

export const MainTitle = ({
  title, titleColor, insurer, topTitle, bottomTitle, bottomTitleColor, topTitleColor,
}) => {

  return topTitle && bottomTitle ? (
    <div style={styles.topContainer}>
      <div style={styles.internalContainer}>
        <div style={styles.textContainer}>
          <Text style={{ ...styles.topTitle, color: topTitleColor }}>{topTitle}</Text>
          <Text style={{ ...styles.meddiumTitle, borderColor: titleColor }}>
            {title || 'Relatório de saúde preventiva'}
          </Text>
        </div>
        <MainTitleLogo
          insurer={insurer}
        />
      </div>
      <Text style={{ ...styles.bottomTitle, color: bottomTitleColor }}>{bottomTitle}</Text>

    </div>
  )
    : (
      <div style={styles.container}>
        <Text style={{ ...styles.title, borderColor: titleColor }}>
          {title || 'Relatório de saúde preventiva'}
        </Text>
        <MainTitleLogo insurer={insurer} />
      </div>
    )
}

MainTitle.propTypes = {
  titleColor: PropTypes.string.isRequired,
  title: PropTypes.string,
  insurer: PropTypes.string.isRequired,
  topTitle: PropTypes.string,
  bottomTitle: PropTypes.string,
  bottomTitleColor: PropTypes.string,
  topTitleColor: PropTypes.string,
}

MainTitle.defaultProps = {
  title: '',
  topTitle: '',
  bottomTitle: '',
  bottomTitleColor: '',
  topTitleColor: '',
}
